import gql from 'graphql-tag';

export const GET_ALL_COMPANIES = gql`
  query GetCompanies {
    companies {
      _id
      name
      accountId {
        _id
        name
        email
      }
      stripe {
        stripeCustomerId
        stripeSubscriptionId
        stripeAccountId
      }
    }
  }
`;

export const CREATE_COMPANY = gql`
  mutation CreateCompany($company: CompanyInsertInput!) {
    insertOneCompany(data: $company) {
      _id
    }
  }
`;

export const UPDATE_COMPANY = gql`
  mutation UpdateCompany($query: CompanyQueryInput!, $set: CompanyUpdateInput!) {
    updateOneCompany(query: $query, set: $set) {
      _id
    }
  }
`;

export const GET_ONE_COMPANY = gql`
  query GetOneCompany($query: CompanyQueryInput!) {
    company(query: $query) {
      _id
      name
      billingManagement
      libraries
      phone
      logo
      address {
        address1
        address2
        city
        postCode
        country
        state
      }
      shipping {
        address1
        address2
        city
        postCode
        country
        state
      }
      country
      accountId {
        _id
        name
        email
      }
      stripe {
        stripeCustomerId
        stripeSubscriptionId
        stripeAccountId
        stripeSubscriptionStatus
      }
      settings {
        isTaxInclusive
        timeZone
        enablePaymentTerminalTipping
        automaticallyPrintReceipt
        defaultLanguage
        currency
        companyUrl
        apiPassword
        apiKey
      }
    }
  }
`;

export const GET_ALL_COMPANIES_BY_SEARCH = gql`
  query GetCompaniesBySearch($searchValue: String!, $limit: Int, $accountId: String) {
    SearchCompanies(input: { searchTerms: $searchValue, limit: $limit, _id: $accountId }) {
      companies {
        _id
        name
        accountId
        accountName
        accountEmail
        stripe {
          stripeCustomerId
          stripeSubscriptionId
          stripeAccountId
        }
      }
    }
  }
`;

export const GET_ALL_COMPANIES_BY_ACCOUNT_ID = gql`
  query GetCompaniesByAccount($accountId: ObjectId!) {
    companies(query: { accountId: { _id: $accountId } }) {
      _id
      name
      accountId {
        _id
        name
        email
      }
      stripe {
        stripeCustomerId
        stripeSubscriptionId
        stripeAccountId
        onlineRate
        onlineFixedRate
        storeRate
        storeFixedRate
        stripeSubscriptionStatus
      }
    }
  }
`;
